import { DataSourceMyBagTotalsQueryProviderProps } from "./data-source--mybag-totals-query-provider";

export type DataSource_MyBag_Totals_QueryKeyType = [
  string,
  Omit<DataSourceMyBagTotalsQueryProviderProps, "useInitialState">
];

const mybagTotals_baseKey = `bbnt-data-source-mybag-totals-provider`;

export const DataSource_MyBag_Totals_QueryKey = {
  mybagTotalsInvalidationKey: () => mybagTotals_baseKey,
  mybagTotals: (
    desiredBag: DataSourceMyBagTotalsQueryProviderProps
  ): DataSource_MyBag_Totals_QueryKeyType => {
    const baseQueryKey = mybagTotals_baseKey;

    const { useInitialState, ...desiredBag_cleaned } = {
      ...desiredBag,
    };

    const queryKey: DataSource_MyBag_Totals_QueryKeyType = [
      baseQueryKey,
      desiredBag_cleaned,
    ];

    return queryKey;
  },
};
